import CampaignIcon from '@mui/icons-material/Campaign';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BlockIcon from '@mui/icons-material/Block';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import {
  Box,
  // Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Toolbar,
  // Typography
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/img/logo.png';

const sidebarItems = [
  {
    label: 'Campaigns',
    icon: <CampaignIcon />,
    path: '/campaigns'
  },
  {
    label: 'Campaign Logs',
    icon: <ListAltIcon />,
    path: '/campaign-logs'
  },
  {
    label: 'MSISDN Blacklist',
    icon: <BlockIcon />,
    path: '/msisdn-blacklist'
  },
  {
    label: 'Audit Trail',
    icon: <RuleFolderIcon />,
    path: '/audit-trail'
  },
  {
    label: 'Source Channel',
    icon: <SettingsInputAntennaIcon />,
    path: '/source-channels'
  }
];

const SidebarContent = ({ onNavigate }) => {
  const location = useLocation();
  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Toolbar
        sx={{
          px: 3,
          minHeight: 72
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            component="img"
            src={logo}
            alt="MRT CMS logo"
            sx={{
              
            }}
          />
        </Box>
      </Toolbar>
      {/* <Divider /> */}
      <Box sx={{ flexGrow: 1, overflowY: 'auto', py: 2 }}>
        <List
          subheader={
            <ListSubheader
              component="div"
              sx={{
                lineHeight: 1,
                mb: 1,
                px: 3,
                fontSize: 11,
                textTransform: 'uppercase',
                letterSpacing: '0.18em',
                color: 'text.secondary'
              }}
            >
              Management
            </ListSubheader>
          }
          sx={{ px: 1 }}
        >
          {sidebarItems.map((item) => (
            <ListItemButton
              key={item.path}
              selected={isActive(item.path)}
              onClick={() => onNavigate(item.path)}
              sx={{
                mb: 0.75,
                mx: 1,
                borderRadius: 0.5,
                '& .MuiListItemText-primary': {
                  fontWeight: 500,
                  fontSize: 14,
                }
              }}
            >
              <ListItemIcon sx={{ color: 'inherit', minWidth: 32 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
      </Box>      
    </Box>
  );
};

const Sidebar = ({ drawerWidth, mobileOpen, onToggleSidebar, container }) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    onToggleSidebar();
  };

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label="sidebar navigation"
    >
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onToggleSidebar}
        ModalProps={{ keepMounted: true }}
        container={container}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            borderRight: 0
          }
        }}
      >
        <SidebarContent onNavigate={handleNavigate} />
      </Drawer>
      <Drawer
        variant="permanent"
        open
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            borderRight: '1px solid',
            borderColor: 'divider'
          }
        }}
      >
        <SidebarContent onNavigate={navigate} />
      </Drawer>
    </Box>
  );
};

export default Sidebar;
